const isAccessibilityEnabled = ()=>{
    return String(window.amplify_lantern_config.isAccessibilityEnabled) === 'true';
};

export default isAccessibilityEnabled;
